export enum ModalNames {
  addressRequired = 'addressRequired',
  addToCart = 'addToCart',
  buyingOptions = 'buyingOptions',
  changePassword = 'changePassword',
  connectingBank = 'connectingBank',
  consumerDistanceFilter = 'consumerDistanceFilter',
  deliveryAddress = 'deliveryAddress',
  discountQualification = 'discountQualification',
  emptyCart = 'emptyCart',
  login = 'login',
  marketplaceDistanceFilter = 'marketplaceDistanceFilter',
  orderReceipt = 'orderReceipt',
  orderStatus = 'orderStatus',
  orderType = 'orderType',
  orderTypeTakeover = 'orderTypeTakeover',
  resetPassword = 'resetPassword',
  selectStore = 'selectStore',
  signUp = 'signUp',
  dutchiePayCta = 'dutchiePayCta',
  dutchiePayRelinkBankAccount = 'dutchiePayRelinkBankAccount',
  dutchiePayVisitOnDesktop = 'dutchiePayVisitOnDesktop',
  termsOfService = 'termsOfService',
  chainLocationBrowser = 'chainLocationBrowser',
  postSignupLoyaltyJoin = 'postSignupLoyaltyJoin',
  postSignupBankLink = 'postSignupBankLink',
  postSignupLoyaltyPass = 'postSignupLoyaltyPass',
  phoneVerificationNudge = 'phoneVerificationNudge',
}
